export default __webpack_public_path__ + "static/control-crypto-mobile-dbd4ab479ebf373feadf74d83daead83.svg";